import { render } from "./ViewAccountPage.vue?vue&type=template&id=20ab3604&scoped=true"
import script from "./ViewAccountPage.vue?vue&type=script&lang=js"
export * from "./ViewAccountPage.vue?vue&type=script&lang=js"

import "./ViewAccountPage.vue?vue&type=style&index=0&id=20ab3604&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ab3604"]])

export default __exports__